<template>
  <div>
    <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
    <MensagemFlutuante 
      :mensagemVisivel="mensagemFlutuante.mensagemVisivel" 
      :titulo="mensagemFlutuante.tituloMensagem"
      :estilo="mensagemFlutuante.estiloMensagem" 
      :texto="mensagemFlutuante.textoMensagem" 
      @close="fecharMensagem" 
    />
  </div>
</template>

<script>
import Excecao from '../../utils/excecao';
import MensagemFlutuante from '../shared/MensagemFlutuante';
import Loading from '../shared/Loading';
import { configurarUsuarioNoSentry } from '../../utils/lib/sentryInit';

export default {
  name: 'LoginSeguranca',
  components: { MensagemFlutuante, Loading },
  mounted() {
    this.validarAutenticacaoNoSeguranca();
  },
  data() {
    return {
      loading: {
        visivel: false,
        mensagem: 'Só um momento, estamos carregando as informações do usuário'
      },
      mensagemFlutuante: {
        mensagemVisivel: false,
        tituloMensagem: '',
        estiloMensagem: '',
        textoMensagem: ''
      }
    };
  },
  beforeCreate() {
    if (this.$usuario.estaLogado()) {
      this.$router.push({ name: 'ConsultaPorCpf' });
    }
  },
  methods: {
    obterIdentificadorDoUsuarioDaUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('identificadorDoUsuario');
    },    
    limparQueryStringDaUrl() {
      const url = new URL(window.location.href);
      url.searchParams.delete('identificadorDoUsuario');      
      url.searchParams.delete('redirect');
      
      const novaUrl = url.origin + url.pathname + (url.search ? url.search : '') + url.hash;
      window.history.replaceState({}, '', novaUrl);
      
      sessionStorage.removeItem('ultimoRedirecionamentoSeguranca');
    },
    async validarAutenticacaoNoSeguranca() {
      let identificadorDoUsuario = this.obterIdentificadorDoUsuarioDaUrl();
      
      if (!identificadorDoUsuario) {
        this.redirecionarParaAutenticacaoNoSeguranca();
        return;
      }

      this.limparQueryStringDaUrl();
      this.ativarLoading();

      const informacoesDeLogin = await this.obterInformacoesDeLoginNoSeguranca(identificadorDoUsuario);
      if (!informacoesDeLogin) return;

      try {
        const tokenDeAutorizacaoDoKeycloak = informacoesDeLogin.Token;

        if (tokenDeAutorizacaoDoKeycloak) {
          await this.obterTokenDoSeguranca(tokenDeAutorizacaoDoKeycloak);
        } else {
          throw new Excecao('Token de autorização não encontrado na resposta');
        }
        this.desativarLoading();
      } catch (error) {
        this.tratarMensagemDeErro(error);
        this.desativarLoading();
      }
    },
    async obterInformacoesDeLoginNoSeguranca(identificadorDoUsuario) {
      try {
        const response = await this.$usuario.obterInformacoesDeAutenticacaoDoSeguranca(identificadorDoUsuario);
        return response.data;
      } catch (error) {
        this.redirecionarParaPaginaDeErroDoSeguranca();
        return null;
      }
    },
    redirecionarParaPaginaDeErroDoSeguranca() {
      const returnUrl = window.location.origin + window.location.pathname;
      const mensagem = 'Não foi possível concluir o seu acesso ao Controle de Saldo. Clique em Voltar para entrar novamente.';

      window.location.href = `${process.env.URL_API_SEGURANCA}/Error/ErrorNaoAutenticado?mensagem=${encodeURIComponent(mensagem)}&returnUrl=${encodeURIComponent(returnUrl)}`;
    },
    redirecionarParaAutenticacaoNoSeguranca() {
      const ultimoRedirecionamento = sessionStorage.getItem('ultimoRedirecionamentoSeguranca');
      const agora = Date.now();
      
      if (ultimoRedirecionamento && (agora - parseInt(ultimoRedirecionamento)) < 2000) {
        this.exibirMensagemDeErro('Erro ao autenticar. Por favor, recarregue a página.');
        return;
      }
      
      sessionStorage.setItem('ultimoRedirecionamentoSeguranca', agora.toString());
      
      const redirect = this.$route.query.redirect || new URLSearchParams(window.location.search).get('redirect');
      if (redirect) {
        sessionStorage.setItem('redirectAposLogin', redirect);
      }
      
      const returnUrl = window.location.origin + window.location.pathname;      
      const urlAutenticacaoSeguranca = `${process.env.URL_API_SEGURANCA}/Seguranca/LogOnExternoViaCookie?ReturnUrl=${encodeURIComponent(returnUrl)}`;
      
      window.location.href = urlAutenticacaoSeguranca;
    },    
    async obterTokenDoSeguranca(tokenDeAutorizacaoDoKeycloak) {
      try {
        const response = await this.$usuario.login(tokenDeAutorizacaoDoKeycloak);
        const tokenDoSeguranca = response.data.access_token;
        
        if (tokenDoSeguranca === null || tokenDoSeguranca === undefined) {
          throw new Excecao('Dados de acesso inválidos');
        }

        await this.salvarDadosDeAcesso(tokenDoSeguranca, tokenDeAutorizacaoDoKeycloak);
        const usuarioLogado = this.$usuario.obterUsuarioLogado().login;

        configurarUsuarioNoSentry(usuarioLogado);
        this.configurarProductFruits(usuarioLogado);

        this.$gerenciadorDeTermos.verificarSeAceitouTermosEmVigor(usuarioLogado).then((response) => {
          const aceitouOsTermosEmVigor = response.data;
          if (aceitouOsTermosEmVigor) {
            const redirect = sessionStorage.getItem('redirectAposLogin') || this.$route.query.redirect || '/';
            sessionStorage.removeItem('redirectAposLogin');
            this.$router.push({ path: redirect });
          } else {
            this.$gerenciadorDeTermos.redirecionarParaOGerenciadorDeTermos(usuarioLogado);
          }
        });
      } catch (error) {
        this.tratarMensagemDeErro(error);
      }
    },
    configurarProductFruits(usuarioLogado) {
      if (window.$productFruits) {
        window.$productFruits.push([
          'init',
          'nvkDXtunNMfkiazA',
          'pt',
          {
            username: usuarioLogado
          }
        ]);
      }
    },
    tratarMensagemDeErro(erro) {
      let mensagem = 'Ocorreu um erro ao autenticar. Tente novamente.';
      
      if (erro && erro.mensagem) {
        mensagem = erro.mensagem;
      } else if (erro && erro.response && erro.response.data && erro.response.data.error_description) {
        mensagem = erro.response.data.error_description;
      } else if (erro && erro.message) {
        mensagem = erro.message;
      }
      
      this.exibirMensagemDeErro(mensagem);
    },
    async salvarDadosDeAcesso(tokenDoSeguranca, tokenDeAutorizacaoDoKeycloak) {
      await this.$usuario.obterPermissoes(tokenDoSeguranca).then(async (resp) => {
        let dados = resp.data || [];
        this.$usuario.guardarSessao(dados.usuarioDoSeguranca, dados.nomeDoUsuario, dados.emailDoUsuario, tokenDoSeguranca, tokenDeAutorizacaoDoKeycloak);
        this.$usuario.guardarPermissoes(dados.permissoes);
      }).catch((error) => {
        this.tratarMensagemDeErro(error);
      });
    },
    exibirMensagemDeErro(mensagem) {
      let estiloDaMensagem = 'erro';
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemFlutuante = {
        mensagemVisivel: true,
        tituloMensagem: tituloDaMensagem || '',
        estiloMensagem: estiloDaMensagem,
        textoMensagem: mensagem
      }

      setTimeout(() => { this.fecharMensagem() }, 10000);
    },
    fecharMensagem() {
      this.mensagemFlutuante.mensagemVisivel = false;
    },
    ativarLoading() {
      this.loading = {
        visivel: true,
        mensagem: 'Só um momento, estamos carregando as informações do usuário'
      };
    },
    desativarLoading() {
      this.loading.visivel = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Login.vue?6d910c8c